function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4.48807C0 2.35049 2.17189 0.898714 4.14706 1.71602L28.1471 11.6471C29.2686 12.1111 30 13.2053 30 14.4191V30L1.2353 18.0974C0.487595 17.788 0 17.0585 0 16.2493V4.48807Z",
  fill: "url(#paint0_linear_486_44324)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 40.0079C0 41.433 1.44793 42.4009 2.7647 41.856L27.5294 31.6085C29.0248 30.9897 30 29.5308 30 27.9125V13L1.2353 24.9026C0.487595 25.212 0 25.9415 0 26.7507V40.0079Z",
  fill: "url(#paint1_linear_486_44324)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_486_44324",
  x1: 0,
  y1: 0,
  x2: 30,
  y2: 26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1406,
  stopColor: "#2EEEE2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2EEEE2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_486_44324",
  x1: -0.5,
  y1: 42.5,
  x2: 30,
  y2: 15.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.630208,
  stopColor: "#996CFC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5062F1"
})));

function SvgStripeLogoMulticolor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 43,
    viewBox: "0 0 30 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref3), _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogoMulticolor);
export default __webpack_public_path__ + "static/media/Stripe_logo_multicolor.05eb0f55.svg";
export { ForwardRef as ReactComponent };